export default "__VITE_ASSET__0e3253ee__"